import { useRouter } from "next/router";
import { useEffect } from "react";

export function useOnQueryShowErrors(callback: () => void) {
  const router = useRouter();

  useEffect(() => {
    if (router.query.validate !== undefined) {
      callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.showErrors]);
}
